import { createApp } from 'vue'
import CaseCard from './CaseCard'

const el = '.kb-component--case-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((CaseCardDOM) => {
            const component = createApp(CaseCard).use(Store)
            component.mount(CaseCardDOM)
        })
    }
}
